export const usersData$ = (state) => state.user.userData;
export const userLoading$ = (state) => state.user.isLoading;
export const userRefreshing$ = (state) => state.user.isRefreshing;
export const userDemoLoggingIn$ = (state) => state.user.isDemoLoggingIn;
export const userError$ = (state) => state.user.error;
export const userSignupSuccess$ = (state) => state.user.isSignupSuccess;
export const userForgotPasswordLoading$ = (state) => state.user.isForgotPasswordLoading;
export const userForgotPasswordSuccess$ = (state) => state.user.isForgotPasswordSuccess;
export const userForgotPasswordError$ = (state) => state.user.forgotPasswordError;
export const userResetPasswordLoading$ = (state) => state.user.isResetPasswordLoading;
export const userResetPasswordSuccess$ = (state) => state.user.isResetPasswordSuccess;
export const userResetPasswordError$ = (state) => state.user.resetPasswordError;
export const userCookieSetHeaderSent$ = (state) => state.user.cookieSetHeaderSent;
export const userCookieConfirmed$ = (state) => state.user.cookieConfirmed;
export const userUploadingAvatar$ = (state) => state.user.isUploadingAvatar;
export const userUploadedAvatarUrl$ = (state) => state.user.uploadedAvatarUrl;
export const userUploadAvatarError$ = (state) => state.user.uploadAvatarError;